import { shortUrlEndpointIds } from 'root/src/server/modules/shortUrl/shortUrl.fixture';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const listShortUrlsEndpoint = {
    [shortUrlEndpointIds.LIST_SHORT_URLS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payload: {
            type: 'object',
            properties: {
                page: {
                    type: 'number',
                },
                limit: {
                    type: 'number',
                },
                alias: {
                    type: 'string',
                },
                url: {
                    type: 'string',
                },
            },
        },
    },
};
